export const TABLE_KEYS = {
    FUTURE_DEVIATIONS: 'FutureDeviations',
    FUTURE_MARKET_PRICES: 'FutureMarketPrices',
    VIEW_FUTURE_DEVIATIONS: 'vwFutureDeviations',
    VIEW_FUTURE_MARKET_PRICES: 'vwFutureMarketPrices',
};

export const QUERY_KEYS = {
    FUTURE_DEVIATIONS: 'futureDeviations',
    FUTURE_MARKET_PRICES: 'futureMarketPrices',
};

export const SCHEMAS = {
    APP: 'app',
    DBO: 'dbo',
};
